module.exports = __webpack_public_path__ + "static/media/logo-mastercard-securecode.e208a2c8.svg";